import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input} from 'react-bootstrap'
import {connectForm, checkboxField} from '../../core/redux/form'
import {LoaderForm} from '../../core/redux/loading'
import Card from '../../core/components/Card'
import {AUTHENTICATED_USER_CONFIGS_UPDATED, AUTHENTICATED_USER_CONFIGS_SENT} from '../actions'
import {UserConfigs} from '../models'
import i18n from '../i18n'

class UserConfigsCard extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, form, authenticatedConfigs, loading, ...others} = this.props

        const header = (
            <h5>{i18n.userConfigs}</h5>
        )

        return (
            <Card
                header={header}
                {...others}>
                <LoaderForm
                    loading={loading}
                    action={AUTHENTICATED_USER_CONFIGS_SENT}>
                    {authenticatedConfigs.ticketOpenedNotifications !== undefined && (
                        <Input
                            type='checkbox'
                            name='ticketOpenedNotifications'
                            label={i18n.ticketOpenedNotifications}
                            {...checkboxField(form.ticketOpenedNotifications())} />
                    )}
                    {authenticatedConfigs.daybookNotifications !== undefined && (
                        <Input
                            type='checkbox'
                            name='daybookNotifications'
                            label={i18n.daybookNotifications}
                            {...checkboxField(form.daybookNotifications())} />
                    )}
                    {authenticatedConfigs.simplifiedRequestOpenedNotifications !== undefined && (
                        <Input
                            type='checkbox'
                            name='simplifiedRequestOpenedNotifications'
                            label={i18n.simplifiedRequestOpenedNotifications}
                            {...checkboxField(form.simplifiedRequestOpenedNotifications())} />
                    )}
                </LoaderForm>
            </Card>
        )
    }
}

UserConfigsCard = connectForm({
    alias: 'userConfigs',
    target: 'authenticatedConfigs',
    schema: UserConfigs.schema,
    action: AUTHENTICATED_USER_CONFIGS_UPDATED
})(UserConfigsCard)

UserConfigsCard = connect((state) => ({
    loading: state.loading,
    authenticatedConfigs: state.user.authenticatedConfigs
}))(UserConfigsCard)

export default UserConfigsCard


// WEBPACK FOOTER //
// ./lib/user/components/UserConfigsCard.js